import { Component } from '@angular/core';

@Component({
  selector: 'app-main-payment-documents',
  templateUrl: './main-payment-documents.component.html',
  styleUrls: ['./main-payment-documents.component.css'],
})
export class MainPaymentDocumentsComponent {}
